import { useEffect, useRef, useState } from 'react';
import { getTransform } from '../../common/tooltip/tooltipHelper';
import { formatValue } from '../../support';
export function createCategoryTooltipController(config) {
    const { strategy: { format }, } = config;
    return {
        useProps(props) {
            const [tooltipContent, setTooltipContent] = useState(null);
            const hideTooltipTimeoutRef = useRef(null);
            useEffect(() => {
                return () => {
                    if (hideTooltipTimeoutRef.current !== null) {
                        clearTimeout(hideTooltipTimeoutRef.current);
                        hideTooltipTimeoutRef.current = null;
                    }
                };
            }, []);
            const interactionMode = config.options.interaction;
            const trigger = {
                onEnter(event, { dataset, dataIndex }) {
                    if (hideTooltipTimeoutRef.current !== null) {
                        clearTimeout(hideTooltipTimeoutRef.current);
                        hideTooltipTimeoutRef.current = null;
                    }
                    const value = dataset.data[dataIndex] ?? null;
                    const formattedValue = formatValue(config.strategy.format, props.axes.scalar.format ?? null, value, {
                        notation: 'long',
                    });
                    const newTooltipContent = {
                        label: props.labels[dataIndex]?.label,
                        left: event.pageX - 20,
                        top: event.pageY - 20,
                        xAlign: 'left',
                        yAlign: 'bottom',
                        dataset: dataset,
                        data: {
                            raw: value,
                            formattedValue,
                        },
                        previous: null,
                        change: null,
                        dataIndex: dataIndex,
                    };
                    setTooltipContent(newTooltipContent);
                },
                onLeave(dataset) {
                    hideTooltipTimeoutRef.current = window.setTimeout(() => {
                        setTooltipContent(null);
                        hideTooltipTimeoutRef.current = null;
                    }, 300);
                },
            };
            if (!tooltipContent) {
                return {
                    visible: false,
                    trigger,
                };
            }
            return {
                visible: true,
                trigger,
                state: tooltipContent,
                root: {
                    position: 'absolute',
                    left: `${tooltipContent.left}px`,
                    top: `${tooltipContent.top}px`,
                    transform: getTransform(tooltipContent.xAlign, tooltipContent.yAlign),
                },
                custom: interactionMode === 'nearest'
                    ? {
                        mode: interactionMode,
                        label: tooltipContent.label,
                        dataset: tooltipContent.dataset,
                        data: tooltipContent.data,
                        axes: props.axes,
                        change: tooltipContent.change,
                        previous: tooltipContent.previous,
                    }
                    : {
                        mode: interactionMode,
                        label: tooltipContent.label,
                        datasets: props.datasets,
                        dataIndex: tooltipContent.dataIndex,
                        axes: props.axes,
                    },
            };
        },
    };
}
//# sourceMappingURL=categoryTooltipController.js.map